var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "div",
        { staticClass: "modal-popup", on: { click: _vm.handleOverlayClick } },
        [
          _c(
            "div",
            {
              staticClass: "popup google-refresh-popup",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("div", { staticClass: "google-refresh-content" }, [
                _c("div", { staticClass: "page-header" }, [
                  _vm._m(0),
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("onboarding.google_refresh.title"))),
                  ]),
                ]),
                _c("p", { staticClass: "explanation" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("onboarding.google_refresh.explanation")) +
                      "\n      "
                  ),
                ]),
                _c("div", { staticClass: "step-card" }, [
                  _c("div", { staticClass: "step-number" }, [_vm._v("1")]),
                  _c("div", { staticClass: "step-content" }, [
                    _c("p", { staticClass: "step-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("onboarding.google_refresh.step1_title"))
                      ),
                    ]),
                    _c("p", { staticClass: "step-description" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("onboarding.google_refresh.step1_description")
                        )
                      ),
                    ]),
                    _c(
                      "a",
                      {
                        staticClass: "step-link",
                        attrs: {
                          href: "https://myaccount.google.com/connections",
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "onboarding.google_refresh.step1_link_text"
                              )
                            ) +
                            "\n            "
                        ),
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 14 14",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333",
                                stroke: "currentColor",
                                "stroke-width": "1.3",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M9 1H13V5",
                                stroke: "currentColor",
                                "stroke-width": "1.3",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M5.66699 8.33333L13.0003 1",
                                stroke: "currentColor",
                                "stroke-width": "1.3",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "step-card" }, [
                  _c("div", { staticClass: "step-number" }, [_vm._v("2")]),
                  _c("div", { staticClass: "step-content" }, [
                    _c("p", { staticClass: "step-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("onboarding.google_refresh.step2_title"))
                      ),
                    ]),
                    _c("p", { staticClass: "step-description" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("onboarding.google_refresh.step2_description")
                        )
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "buttons" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button btn-outline-primary",
                      on: { click: _vm.handleSkip },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("onboarding.google_refresh.button_skip")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "button btn-primary",
                      on: { click: _vm.handleReconnect },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("onboarding.google_refresh.button_reconnect")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-avatar" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/img/iconsNetwork/ico-google-2x.png"),
          alt: "Google",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }